module.exports = __webpack_public_path__ + "1ef323c0e3e71318dbc2985b72b33551.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/server-product/images/tutu.png
// module id = 2475
// module chunks = 31